import React from "react";

import Servicespage from "../Public_Components/Servicespage";

function Services() {
  return (
    <>
     
      <Servicespage/>
      
      
     
    </>
  );
}

export default Services;
